import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { LoadingContainer } from "go-core/components/Loading";
import { OrderTransactionStatus } from "../../../../../../services/Api/Public/types";
import OrderProcessPayment from "../../components/OrderProcessPayment";
import PaymentInfoModal from "../../components/PaymentInfoModal";
import { OrderContext } from "../../contexts/OrderContext";
import { useParentGoBackMessage } from "../../hooks";
import { CompanyInfoSection } from "./components/CompanyInfo/CompanyInfoSection";
import OrderFooterPayment from "./components/Footer/OrderFooterPayment";
import { GoPOSSection } from "./components/GoPOSInfo/GoPOSSection";
import { OrderDetailsSection } from "./components/OrderDetails/OrderDetailsSection";
import OrderInfoSection from "./components/OrderInfo/OrderInfoSection";
import OrderPaymentSection from "./components/OrderPayment/OrderPaymentSection";
import OrderStatusDetailsSection from "./components/OrderStatusDetails/OrderStatusDetailsSection";

const EOrderIndexPage = () => {
	const { order, paymentSuccess, setPaymentSuccess, setTipAmount } = useContext(OrderContext);
	const [showPaymentInfoModal, setShowPaymentInfoModal] = useState<OrderTransactionStatus | undefined>();
	const { search } = useLocation();
	const urlSearchParams = new URLSearchParams(search);
	const paymentInProgress = order?.payment_online_in_progress ?? false;
	const orderPaymentStatus = urlSearchParams.get("orderTransactionStatus");
	useParentGoBackMessage(true);

	useEffect(() => {
		setTipAmount(undefined);
	}, []);

	useEffect(() => {
		if (paymentSuccess && !paymentInProgress) {
			setShowPaymentInfoModal(OrderTransactionStatus.SUCCESS);
			setPaymentSuccess(false);
		}
		if (orderPaymentStatus === "success" && !paymentInProgress) {
			setShowPaymentInfoModal(OrderTransactionStatus.SUCCESS);
		}
		if (orderPaymentStatus === "error") {
			setShowPaymentInfoModal(OrderTransactionStatus.ERROR);
		}
	}, [paymentSuccess, orderPaymentStatus, paymentInProgress]);

	if (!order) {
		return <LoadingContainer />;
	}

	return (
		<>
			<main>
				<CompanyInfoSection company={order.company} />
				<OrderInfoSection details={order} />
				<OrderStatusDetailsSection />
				<OrderDetailsSection details={order} />
				<OrderPaymentSection />
				<GoPOSSection />
			</main>
			<OrderFooterPayment />
			{order.payment_online_in_progress && (
				<OrderProcessPayment paymentType={order.payment_online_in_progress_type} />
			)}
			{showPaymentInfoModal && (
				<PaymentInfoModal
					status={showPaymentInfoModal}
					show={!!showPaymentInfoModal}
					onHide={() => setShowPaymentInfoModal(undefined)}
				/>
			)}
		</>
	);
};

export default EOrderIndexPage;
